class HttpConfig {

	constructor(config) {
		for(let key in config) {
			this[key] = config[key];
		}
	}

	addQueryParams(queryParams) {
		if(!queryParams || !this.url || Object.keys(queryParams).length == 0) {
			return;
		}

		for(let paramName in queryParams) {
			this.addQueryParam(paramName, queryParams[paramName]);
		}
	}

	addQueryParam(paramName, paramValue) {
		if(!paramName || !paramValue || !this.url) {
			return;
		}

		if(this.url.indexOf('?') > -1) {
			this.url = this.url + "&" + paramName + "=" + paramValue;
		} else {
			this.url = this.url + "?" + paramName + "=" + paramValue;
		}
	}

	addHeaders(headers) {
		if(!headers || Object.keys(headers) == 0) {
			return;
		}

		for(let headerName in headers) {
			this.addHeader(headerName, headers[headerName]);
		}
	}

	addHeader(headerName, headerValue) {
		if(!headerName || !headerValue) {
			return;
		}

		if(!this.headers) {
			this.headers = {};
		}

		this.headers[headerName] = headerValue;
	}
}

export default HttpConfig;




// WEBPACK FOOTER //
// ../common/utils/http/HttpConfig.js